import { AlertTriangle, Info, CheckCircle2 } from "lucide-react";

export function AlertWidget({ widget }) {
  const alerts = Array.isArray(widget.data) ? widget.data : [];
  return (
    <div className="bg-card rounded-xl border border-border p-5 shadow-sm" data-testid={`widget-${widget.widgetKey}`}>
      <h3 className="font-semibold text-foreground mb-4">{widget.title}</h3>
      {alerts.length === 0 ? (
        <div className="flex items-center gap-2 text-sm text-emerald-500">
          <CheckCircle2 className="h-4 w-4" /> All clear
        </div>
      ) : (
        <div className="space-y-2.5">
          {alerts.map((a, i) => (
            <div key={i} className="flex items-center gap-2 text-sm text-foreground">
              {a.level === "warning"
                ? <AlertTriangle className="h-4 w-4 text-amber-500 flex-shrink-0" />
                : <Info className="h-4 w-4 text-sky-500 flex-shrink-0" />}
              <span>{a.message}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
